import React, { forwardRef, Ref } from 'react';
import { Button, Text, Icon } from '@cashfree-intl/coherent';
import { StyledPopoverTrigger } from './styled';

interface FilterPopoverTriggerProps {
  open: boolean;
  text: string;
  appliedFiltersCount?: number;
}

const FilterPopoverTrigger = forwardRef(
  (
    {
      open,
      text,
      appliedFiltersCount = 0,
      ...props
    }: FilterPopoverTriggerProps,
    ref: Ref<HTMLDivElement>,
  ) => (
    <StyledPopoverTrigger ref={ref} {...props}>
      <Button
        icon={
          <Icon name={open ? 'chevron-up' : 'chevron-down'} className="ml-1" />
        }
        iconPosition="right"
      >
        {appliedFiltersCount > 0 && (
          <Text as="span" color="primary" className="pr-1">
            {appliedFiltersCount}
          </Text>
        )}
        {text}
      </Button>
    </StyledPopoverTrigger>
  ),
);

export default FilterPopoverTrigger;
